import { lighten } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginTop: ({ length, imgsLength }) =>
      length > 1 || imgsLength ? '0.5rem' : '0'
  },

  link: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: '5px',
    textDecoration: 'underline',
    cursor: 'pointer',
    transition: 'color 0.5s',
    whiteSpace: 'break-spaces',
    color: ({ isYours }) => (isYours ? 'white' : theme.palette.primary.main),
    '&:hover': {
      color: lighten(theme.palette.primary.main, 0.3)
    }
  },

  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '1rem',
    maxWidth: '1rem',
    height: '1rem',
    maxHeight: '1rem'
  }
}))

export default useStyles
